import { get } from '../../../utils/get';
export var isAccessible = function (item) {
    if (item === void 0) { item = {}; }
    return get(item, 'challenge.registration.availability') !== 'secret';
};
